import { Box, BoxProps, Image } from '@chakra-ui/react';
import { Show } from '@pelicargo/ui';

import { useCustomerAsset } from '../hooks/tenant/useCustomerAsset';

type Props = BoxProps;

export const CargoPlane = ({ ...rest }: Props) => {
  const planeSrc = useCustomerAsset('plane');

  // The whole decorative box goes when the slot is removed, not just the image inside it.
  const showPlane = !!planeSrc;

  return (
    <Show if={showPlane}>
      <Box position="absolute" right={0} bottom="4" pb="5vh" overflow="hidden" zIndex="1" {...rest}>
        <Image
          src={planeSrc}
          bottom="10%"
          sx={{ perspective: '800px' }}
          width="full"
          right={0}
          zIndex="1"
          alt="airplane"
          opacity="0.5"
        />
      </Box>
    </Show>
  );
};
